import type { PrototypeCatalogEntity } from "../../entity_types/catalog";

export const defaultCatalog: PrototypeCatalogEntity = {
  token: "default",
  type: "catalog",
  name: "Default Catalog",
  categoryTokens: ["default"],
  collectionTokens: ["default"],
  productTokens: ["default"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
